
















































































































import * as Util from '@/util.ts';
import * as Enums from '@/enums.ts';
import * as Constants from '@/constants.ts';
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      allRoutes: Constants.allRoutes,
    };
  },
  computed: {
    isTablesideMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.tableside;
    },
    isTakeoutMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.takeout;
    },
    isDeliveryMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.delivery;
    },
    aboutUsString(): string {
      return Util.t?.aboutUs.supplant([this.$store.state.currentEstablishment.name]);
    },
    establishmentDescription(): string {
      return this.$store.state.currentEstablishment.description;
    },
  },
  methods: {
    routerPush(args: any) {
      Util.routerPush(args);
    },
  },
});
